module.exports = __webpack_public_path__ + "311ed0953b5aafddae58d0277c45416c.jpg";